import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default function PasswordInput({
  value,
  onChange,
  name,
  placeholder,
  required = false,
  autoFocus = false,
  disabled = false,
  className = '',
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={`finance-password-wrap ${className}`.trim()}>
      <input
        type={showPassword ? 'text' : 'password'}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoFocus={autoFocus}
        disabled={disabled}
      />
      <button
        type="button"
        className="finance-password-toggle"
        onClick={() => setShowPassword((prev) => !prev)}
        disabled={disabled}
        aria-label={showPassword ? 'Hide password' : 'Show password'}
        tabIndex={-1}
      >
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </button>
    </div>
  );
}
